import { render, staticRenderFns } from "./PiHistoryPrice.vue?vue&type=template&id=28950b2b&scoped=true"
import script from "./PiHistoryPrice.vue?vue&type=script&lang=ts"
export * from "./PiHistoryPrice.vue?vue&type=script&lang=ts"
import style0 from "./PiHistoryPrice.vue?vue&type=style&index=0&id=28950b2b&prod&scoped=true&lang=scss"
import style1 from "./PiHistoryPrice.vue?vue&type=style&index=1&id=28950b2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28950b2b",
  null
  
)

export default component.exports